import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { modalController } from '@ionic/core';
import { EMPTY, Observable, from, throwError } from 'rxjs';
import { catchError, switchMap, tap } from 'rxjs/operators';
import { I18nPipe } from './pipes/i18n/i18n.pipe';
import { SharedService } from './services/shared/shared.service';
import { UserService } from './services/user/user.service';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  private loggingOut = false;
  private static readonly SKIP_ERROR_TOAST_HEADER = 'X-Skip-Error-Toast';

  constructor(
    private auth: UserService,
    private sharedService: SharedService,
    private i18n: I18nPipe,
  ) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return from(this.auth.getAuthorizationToken()).pipe(
      switchMap(authToken => {
        const skipErrorToast = req.headers.get(AuthInterceptor.SKIP_ERROR_TOAST_HEADER) === 'true';
        let headers = req.headers.delete(AuthInterceptor.SKIP_ERROR_TOAST_HEADER);

        if (authToken && !req.url.includes('portalci2033')) {
          headers = headers.set('Authorization', `Bearer ${authToken}`);
          const authReq = req.clone({ headers });

          return next.handle(authReq).pipe(
            tap((event: HttpEvent<any>) => {
              if (event instanceof HttpResponse) {
                new Promise(async (resolve, reject) => {
                  const user = await this.auth.getUserAuth();
                  if (user.lastLogin == null || user.token == null) resolve(await this.auth.logout());
                });
              }
            }),
            catchError((error: any) => {
              if (error.status === 401 && !this.loggingOut) {
                this.loggingOut = true;
                return from(
                  modalController
                    .dismiss()
                    .catch(() => {})
                    .then(() => this.auth.logout(true))
                    .finally(() => {
                      this.loggingOut = false;
                    }),
                ).pipe(switchMap(() => EMPTY));
              }

              if (error.status !== 200 && !skipErrorToast) {
                try {
                  if (error.error?.message) {
                    this.sharedService.showToast(this.i18n.transform(JSON.parse(error.error.message)));
                  }
                } catch {
                  console.error('Error', error);
                }
              }

              (error as any).__toastHandled = true;
              (error as any).__skipErrorToast = skipErrorToast;

              return throwError(() => error);
            }),
          );
        } else {
          return next.handle(req.clone({ headers }));
        }
      }),
      catchError(error => {
        if ((error as any)?.__toastHandled || (error as any)?.__skipErrorToast) {
          return throwError(() => error);
        }

        try {
          this.sharedService.showToast(this.i18n.transform(JSON.parse(error.error.message)));
        } catch {
          console.error('Error', error);
        }

        return throwError(() => error);
      }),
    );
  }
}
